
import {dd} from 'systems/imports'
import axios from 'axios'
import lodash from 'lodash'
import store from 'store2'

import Container from 'utils/Container';
import config from 'config'
import ResponsiveBootstrapToolkit from 'responsive-toolkit'

Container.singleton("config", () => {
    return config
})

Container.singleton("_", () => {
  return lodash
})

Container.singleton("store", () => {
  return store
})


Container.singleton("axios", () => {
    const http = axios.create({
        baseURL: config.api_url,
        timeout: 20000,
//        headers: {'Authorization': `Bearer xxxxx`}
    })
    http.interceptors.request.use(function (config) {
      config.headers.common['Authorization'] = `Bearer ${store.get("token")}`
      return config;
    }, function (error) {
      return Promise.reject(error);
    });
    return http

})

Container.singleton("adjustLayout", () => {
  return ()=>{
    window.vm.$data.windowWidth = $(window).innerWidth()
    window.vm.$data.windowHeight = $(window).innerHeight()

    //ヘッダーの高さ
    window.vm.$data.headerHeight = $("#header").outerHeight()
    //フッターの高さ
    window.vm.$data.footerHeight = $("#footer").outerHeight()

    //dd("adjust",window.vm.$data.headerHeight,window.vm.$data.footerHeight)
    //BootstrapのPCとスマホレスポンシブ表示で画面を調整する

    // ResponsiveBootstrapToolkit.changed(function() {
    //   console.log('Current breakpoint: ', ResponsiveBootstrapToolkit.current());
    // })

    window.vm.$data.lastAtAdjustLayout = (new Date()).getTime()

    window.vm.$data.bootstrapBreakpoint = (()=>{
      let displayWidth = $(window).innerWidth()
      if(displayWidth >=1200) {
        return "xl";
      }else if(displayWidth >=992){
        return "lg";
      }else if(displayWidth >=768){
        return "md";
      }else if(displayWidth >=576){
        return "sm";
      }else{
        return "xs";
      }
    })()

    setTimeout(()=>{
      window.vm.$data.windowWidth = $(window).innerWidth()
      window.vm.$data.windowHeight = $(window).innerHeight()

      //ヘッダーの高さ
      window.vm.$data.headerHeight = $("#header").outerHeight()
      //フッターの高さ
      window.vm.$data.footerHeight = $("#footer").outerHeight()

      //dd("adjust",window.vm.$data.headerHeight,window.vm.$data.footerHeight)
      //BootstrapのPCとスマホレスポンシブ表示で画面を調整する

      // ResponsiveBootstrapToolkit.changed(function() {
      //   console.log('Current breakpoint: ', ResponsiveBootstrapToolkit.current());
      // })

      window.vm.$data.lastAtAdjustLayout = (new Date()).getTime()

      window.vm.$data.bootstrapBreakpoint = (()=>{
        let displayWidth = $(window).innerWidth()
        if(displayWidth >=1200) {
          return "xl";
        }else if(displayWidth >=992){
          return "lg";
        }else if(displayWidth >=768){
          return "md";
        }else if(displayWidth >=576){
          return "sm";
        }else{
          return "xs";
        }
      })()
    },100)

  };
})

export default Container



// WEBPACK FOOTER //
// ./src/systems/container.js